import { useStaticQuery, graphql } from "gatsby"

export const useTemplate = () =>
  useStaticQuery(graphql`
    query SANITY_TEMPLATE {
      global: sanityTemplateGlobal {
        title
        description
      }
      product: sanityTemplateProduct {
        settingAdditionalPayments: _rawSettingAdditionalPayments(resolveReferences: { maxDepth: 2 })
        settingLowStockThreshold
        settingShowRelatedProducts
        settingEnableShopifyRecommendations
        settingPromoCode: _rawSettingPromoCode(resolveReferences: { maxDepth: 2 })
        promoCalloutText
        promoCode
        additionalAddingToCart
        additionalAddToCart
        additionalCheckout
        additionalOutOfStock
        additionalNotify
        additionalErrorTitle
        additionalErrorDescription
        additionalErrorButton
        additionalSuccessTitle
        additionalSuccessDescription
        additionalSuccessCheckoutButtonText
        addtionalSuccessViewCartButtonText
        addtionalSuccessKeepShoppingButtonText
      }
      productGroup: sanityTemplateProductGroup {
        groups: _rawGroups(resolveReferences: { maxDepth: 10 })
      }
      collection: sanityTemplateCollection {
        featureImageIndex
        additionalLoadMoreButton
      }
    }
  `)
